import { z } from 'zod';

export const favouriteAgentSchema = z.string();
